import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
import { Array2D } from "@lib/titan2/dist/util/collection/Array2D";
import { Dictionary } from "@lib/titan2/dist/util/collection/Dictionary";
import { SlingoConstants } from "../enum/SlingoConstants";
import { Pattern } from "./Pattern";
import { PatternCell } from "./PatternCell";
import { SymbolPayoutData } from "./SymbolPayoutData";
/*
 * PayoutConfigData.ts
 */
export class PayoutConfigData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.solidifySymbolPayouts();
            this.solidifyPatternPayouts();
            this.solidifyPatterns();
        }
    }
    solidifySymbolPayouts() {
        let symbolPayouts = this.data.getDataArray(SlingoConstants.PROPERTY_SYMBOL_PAYOUTS);
        this.symbolPayouts = new Dictionary();
        if (this.dataExists(symbolPayouts)) {
            for (let i = 0; i < symbolPayouts.length; i++) {
                let payout = new SymbolPayoutData(symbolPayouts[i]);
                this.symbolPayouts.setValue(payout.getType(), payout);
            }
        }
    }
    solidifyPatternPayouts() {
        this.patternPayouts = this.data.getNumberArray(SlingoConstants.PROPERTY_PATTERN_PAYOUTS);
    }
    solidifyPatterns() {
        let patterns = this.data.getStringArray(SlingoConstants.PROPERTY_PATTERNS);
        this.patterns = [];
        if (this.dataExists(patterns)) {
            for (let i = 0; i < patterns.length; i++) {
                this.patterns.push(this.createPattern(patterns[i], 5, 5));
            }
        }
    }
    createPattern(pattern, rows, columns) {
        let cells = new Array2D(rows, columns);
        let index = 0;
        for (let row = 0; row < rows; row++) {
            for (let column = 0; column < columns; column++) {
                let cellValue = parseInt(pattern[index++]);
                cells.setValue(row, column, new PatternCell(cellValue));
            }
        }
        return new Pattern(rows, columns, cells);
    }
    getSymbolPayouts() {
        return this.symbolPayouts;
    }
    getPatternPayouts() {
        return this.patternPayouts?.slice();
    }
    getPatterns() {
        return this.patterns?.slice();
    }
    getMaxPayout() {
        return this.patternPayouts[this.patternPayouts.length - 1];
    }
}
//# sourceMappingURL=PayoutConfigData.js.map